<template>
  <div v-if="borrower" class="summary-section" data-type="borrower">
    <div class="summary-section-header sc-header">
      <div class="sc-initials-circle">{{ borrower?.initials || "NN" }}</div>
      <div>{{ borrower?.fullName || "" }}</div>
    </div>
    <div class="summary-section-content">
      <table>
        <tr v-for="field in data" :key="field.name">
          <th class="sc-label">
            {{ field.label || "" }}
          </th>
          <td class="sc-value">
            {{ field.value || "" }}
            <span
              v-if="
                field.name === 'nationalIdNumber' &&
                borrower?.showNationalIdNumberToggle
              "
              class="inline-icon"
              data-type="toggle"
              :class="isMasked ? 'icon-eye' : 'icon-eye-slash'"
              @click="toggleNationalIdNumber"
            ></span>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div v-else class="summary-section" data-type="no-coborrower">
    <div>
      Loan does not have a {{ coborrowerDisplayName || "Co-Applicant" }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { BorrowerVM } from "@/types/certifications";

const props = defineProps<{
  borrower?: BorrowerVM | null;
  coborrowerDisplayName?: string;
}>();

const isMasked = ref<boolean>(true);

const nationalIdNumberDisplay = computed<string>(() =>
  isMasked.value
    ? props.borrower?.nationalIdNumberMasked || ""
    : props.borrower?.nationalIdNumber || ""
);

function toggleNationalIdNumber() {
  isMasked.value = !isMasked.value;
}

const data = computed(() => [
  {
    name: "nationalIdNumber",
    label: props.borrower?.nationalIdNumberLabel || "SSN",
    title: null,
    value: nationalIdNumberDisplay.value,
  },
  {
    name: "dateOfBirth",
    label: "Birthdate",
    title: null,
    value: props.borrower?.birthdate || "",
  },
  {
    name: "address",
    label: "Address",
    title: null,
    value: props.borrower?.addressDisplay || "",
  },
  {
    name: "phoneNumber",
    label: "Phone",
    title: null,
    value: props.borrower?.phoneNumberDisplay || "",
  },
  {
    name: "emailAddress",
    label: "Email",
    title: null,
    value: props.borrower?.emailAddress || "",
  },
  {
    name: "username",
    label: "User",
    title: null,
    value: props.borrower?.username || "",
  },
]);
</script>

<style scoped>
.icon-eye:before,
.icon-eye-slash:before {
  color: #000000;
}
</style>

<style scoped src="@/assets/css/certifications-and-disbursements.css"></style>
